"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var core_1 = require("@material-ui/core");
var styles_1 = require("@material-ui/core/styles");
var useStyles = (0, styles_1.makeStyles)({
    buttonGroup: {
        display: 'block'
    }
});
var FrequencySwitcher = function (_a) {
    var onChange = _a.onChange, frequencies = _a.frequencies, initialFrequency = _a.initialFrequency;
    var _b = (0, react_1.useState)(initialFrequency), selectedFrequency = _b[0], setFrequency = _b[1];
    var classes = useStyles();
    var switchFrequency = function (frequency) {
        if (frequency) {
            setFrequency(frequency);
            onChange(frequency);
        }
    };
    return frequencies ? ((0, jsx_runtime_1.jsxs)(core_1.ButtonGroup, __assign({ className: classes.buttonGroup, color: "primary" }, { children: [frequencies.indexOf('DAILY') >= 0 ? ((0, jsx_runtime_1.jsx)(core_1.Button, __assign({ variant: selectedFrequency == 'DAILY' ? 'contained' : 'outlined', "data-is-active": selectedFrequency === 'DAILY', onClick: function () { return switchFrequency('DAILY'); } }, { children: "\u65E5\u6B21" }))) : null, frequencies.indexOf('WEEKLY') >= 0 ? ((0, jsx_runtime_1.jsx)(core_1.Button, __assign({ variant: selectedFrequency == 'WEEKLY' ? 'contained' : 'outlined', "data-is-active": selectedFrequency === 'WEEKLY', onClick: function () { return switchFrequency('WEEKLY'); } }, { children: "\u9031\u6B21" }))) : null, frequencies.indexOf('MONTHLY') >= 0 ? ((0, jsx_runtime_1.jsx)(core_1.Button, __assign({ variant: selectedFrequency == 'MONTHLY' ? 'contained' : 'outlined', "data-is-active": selectedFrequency === 'MONTHLY', onClick: function () { return switchFrequency('MONTHLY'); } }, { children: "\u6708\u6B21" }))) : null] }))) : null;
};
exports["default"] = FrequencySwitcher;
